import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import { ProductContext } from "../App";
import DeleteIcon from "@mui/icons-material/Delete";

function SellStock() {
  const product_context = useContext(ProductContext);
  const { setAlert, alert, isLoading, setIsLoading } = product_context;
  const ccInputRef = useRef(null);

  const [products, setProducts] = useState();

  const [sellType, setSellType] = useState("online");

  const [sellData, setSellData] = useState([
    {
      itemName: [],
      itemType: [],
      price: "",
      color: [],
      size: [],
    },
  ]);

  const [itemInp, setItemInp] = useState([
    {
      itemName: "",
      itemType: "",
      price: "",
      color: "",
      size: "",
      product_id: "",
    },
  ]);

  const addInputs = () => {
    const item = [
      ...itemInp,
      {
        itemName: "",
        itemType: "",
        price: "",
        color: "",
        size: "",
        product_id: "",
      },
    ];
    const sellItem = [
      ...sellData,
      { itemName: [], itemType: [], price: "", color: [], size: [] },
    ];

    setItemInp(item);
    setSellData(sellItem);
  };

  const itemType = [...new Set(products?.map((el) => el.item_type))] || [""];

  const handleRemove = (e, i) => {
    e.preventDefault();
    let deletedData = [...sellData];
    let deletedata = [...itemInp];
    deletedData.splice(i, 1);
    deletedata.splice(i, 1);
    setSellData(deletedData);
    setItemInp(deletedata);
  };

  const handleChange = (e, i) => {
    const { name, value } = e.target;
    let inputSellData = [...itemInp];
    inputSellData[i][name] = value;

    let inputdata = [...sellData];
    if (name === "itemType") {
      let itemName = [
        ...new Set(
          products
            ?.filter((item) => item.item_type === value)
            ?.map((el) => el.item_name)
        ),
      ];
      document.getElementById(`itemName${i}`).value = "";
      inputdata[i]["itemName"] = itemName;
    } else if (name === "itemName") {
      let itemColor = [
        ...new Set(
          products
            ?.filter(
              (item) =>
                item.item_type === itemInp[i].itemType &&
                item.item_name === value
            )
            ?.map((el) => el.color)
        ),
      ];
      document.getElementById(`color${i}`).value = "";
      inputdata[i]["color"] = itemColor;
    } else if (name === "color") {
      let itemPrice =
        [
          ...new Set(
            products
              ?.filter(
                (item) =>
                  item.item_type === itemInp[i].itemType &&
                  item.item_name === itemInp[i].itemName &&
                  item.color === value
              )
              ?.map((el) => el.price + el.additional_price)
          ),
        ][0] || 0;

      let itemSizetemp = products
        ?.filter(
          (item) =>
            item.item_type === itemInp[i].itemType &&
            item.item_name === itemInp[i].itemName &&
            item.color === value
        )
        ?.map((el) => el.size);

      let productId = [
        ...new Set(
          products
            ?.filter(
              (item) =>
                item.item_type === itemInp[i].itemType &&
                item.item_name === itemInp[i].itemName &&
                item.color === value
            )
            ?.map((el) => el._id)
        ),
      ][0];

      let itemSizearray = [];
      for (let i = 0; i < itemSizetemp?.length; i++) {
        itemSizearray = itemSizearray.concat(itemSizetemp[i]);
      }

      let itemSize = [...itemSizearray];

      itemInp.forEach((el) => {
        if (el.product_id === productId) {
          if (el.size) {
            let index = itemSize.indexOf(el.size);
            itemSize.splice(index, 1);
          }
        }
      });

      inputSellData[i]["product_id"] = productId;

      inputdata[i]["price"] = itemPrice;
      inputdata[i]["size"] = itemSize;
    }
    setSellData(inputdata);
    setItemInp(inputSellData);
  };

  let total_price = 0;
  itemInp.forEach((item) => {
    total_price += Number(item.price);
  });

  useEffect(() => {
    ccInputRef.current && ccInputRef.current.focus();
  }, [sellType]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_SERVER_DOMAIN}/products`)
      .then((res) => {
        let filtered_data = res.data.data.filter((el) => el.quantity !== 0);
        setProducts(filtered_data);
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: "Something Went Wrong",
          type: "danger",
        });
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
    // eslint-disable-next-line
  }, [isLoading]);

  const handleSellSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    let data = {
      purchase_type: sellType,
      customer_details: {
        name: e.target.customerName.value
          ? e.target.customerName.value
          : sellType === "store"
          ? "Store"
          : "Online",
        instagram_id: e.target.instaId?.value,
        address: e.target.address?.value,
        contact_number: e.target.contactNo?.value,
      },
      product_details: itemInp.map((product) => {
        return {
          product_id: product.product_id,
          color: product.color,
          size: product.size,
          price: product.price,
          name: product.itemName,
          type: product.itemType,
        };
      }),
      delivery_instructions: e.target.deliveryInst?.value,
      order_date: new Date(),
      status: sellType === "store" ? "done" : "pending",
      payment_method: e.target.payment_method.value,
      payment:
        e.target.payment_method.value === "COD" ||
        e.target.payment_method.value === "Credit"
          ? "Pending"
          : "Received",
    };

    axios
      .post(`${process.env.REACT_APP_SERVER_DOMAIN}/sell`, data)
      .then((res) => {
        setAlert({
          isOpen: true,
          message: "Product forwarded to sell",
          type: "success",
        });
        e.target.reset();
        setIsLoading(false);
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: err.response.data?.msg,
          type: "danger",
        });
        setIsLoading(false);
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
  };

  return (
    <div>
      <div className="add-items">
        <h1>Sell Items</h1>
        <div className="form-check form-check-inline">
          <input
            onChange={() => {
              setSellType("online");
            }}
            defaultChecked
            className="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio1"
            value="online"
          />
          <label className="form-check-label" htmlFor="inlineRadio1">
            Online
          </label>
        </div>
        <div className="form-check form-check-inline">
          <input
            onChange={() => {
              setSellType("store");
            }}
            className="form-check-input"
            type="radio"
            name="inlineRadioOptions"
            id="inlineRadio2"
            value="store"
          />
          <label className="form-check-label" htmlFor="inlineRadio2">
            Store
          </label>
        </div>

        <form onSubmit={handleSellSubmit}>
          <div className="inputs">
            <label htmlFor="customerName">Customer Name</label>
            <input
              ref={ccInputRef}
              type="text"
              placeholder="Enter Customer Name"
              name="customerName"
            />
          </div>
          {sellType === "online" ? (
            <div className="customer">
              <div className="inputs">
                <label htmlFor="instaId">Intagram ID</label>
                <input
                  type="text"
                  placeholder="Enter Instagram ID"
                  name="instaId"
                />
              </div>
              <div className="inputs">
                <label htmlFor="address">Address</label>
                <input
                  required
                  type="text"
                  placeholder="Enter Customer Address"
                  name="address"
                />
              </div>
              <div className="inputs">
                <label required htmlFor="contactNo">
                  Contact No
                </label>
                <input
                  type="number"
                  placeholder="Enter Contact Number"
                  name="contactNo"
                />
              </div>
            </div>
          ) : null}

          {sellData?.map((item, i) => {
            return (
              <div className="items" key={i}>
                <h5>Item-{i + 1}</h5>
                {i !== 0 ? (
                  <DeleteIcon
                    className="fa-solid fa-trash remove"
                    onClick={(e) => handleRemove(e, i)}
                  ></DeleteIcon>
                ) : null}
                <div className="inputs">
                  <label htmlFor="itemType">Item Type</label>
                  <select
                    ref={sellType === "store" ? ccInputRef : null}
                    required
                    onChange={(e) => handleChange(e, i)}
                    className="form-select"
                    name="itemType"
                    aria-label="Default select example"
                  >
                    <option value="">Type</option>
                    {itemType?.map((type, i) => {
                      return (
                        <option key={i} value={type}>
                          {type}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="inputs">
                  <label htmlFor="itemName">Item Name</label>
                  <select
                    id={`itemName${i}`}
                    required
                    onChange={(e) => handleChange(e, i)}
                    className="form-select"
                    name="itemName"
                    aria-label="Default select example"
                  >
                    <option defaultChecked value="">
                      Name
                    </option>
                    {sellData[i]?.itemName?.map((type, i) => {
                      return (
                        <option key={i} value={type}>
                          {type}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="inputs">
                  <label htmlFor="color">Color</label>
                  <select
                    id={`color${i}`}
                    required
                    onChange={(e) => handleChange(e, i)}
                    className="form-select"
                    name="color"
                    aria-label="Default select example"
                  >
                    <option defaultChecked value="">
                      Color
                    </option>
                    {sellData[i]?.color?.map((type, i) => {
                      return (
                        <option key={i} value={type}>
                          {type}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="inputs">
                  <label htmlFor="size">Size</label>
                  <select
                    required
                    onChange={(e) => handleChange(e, i)}
                    className="form-select"
                    name="size"
                    aria-label="Default select example"
                  >
                    <option defaultChecked value="">
                      Size
                    </option>
                    {sellData[i]?.size?.map((type, i) => {
                      return (
                        <option key={i} value={type}>
                          {type}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="inputs">
                  <label htmlFor="price">Price</label>
                  <input
                    required
                    onChange={(e) => handleChange(e, i)}
                    type="number"
                    placeholder="Enter Price"
                    name="price"
                  />
                </div>
              </div>
            );
          })}
          <button
            type="button"
            onClick={() => addInputs()}
            className="btn btn-secondary mb-3"
          >
            Add More
          </button>

          <div className="inputs">
            <label htmlFor="deliveryInst">Delivery Instructions</label>
            <input
              type="text"
              placeholder="Enter Delivery Instructions"
              name="deliveryInst"
            />
          </div>

          <div className="inputs">
            <label htmlFor="payment_method">Payment Method</label>
            <select
              required
              className="form-select"
              name="payment_method"
              aria-label="Default select example"
            >
              <option value="Cash">Cash</option>
              <option value="COD">COD</option>
              <option value="Online">Online</option>
              <option value="Credit">Credit</option>
            </select>
          </div>

          <p>
            <strong>Total Price:</strong>
            {total_price}
          </p>
          <div className="text-center">
            <button className="btn btn-primary text-center mb-5" type="submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SellStock;
